// extracted by mini-css-extract-plugin
export default {"editableTitle":"CardholderInfo_editableTitle__BcjhW","wrappedAddress":"CardholderInfo_wrappedAddress__OSSjA"};